module.exports = __webpack_public_path__ + "static/media/PM68.cef80d9c.JPG";